import React from 'react'
import Home from './Home/Home'
import About from './About/About'
import Project from './Project/Project'
import Services from './Services/Services'
import Contact from './Contact/Contact'
 

function Homepage() {
  return (
    <>
    <Home/>
    <About/>
    <Project/>
    <Services/>
    <Contact/>
    
    </>
  )
}

export default Homepage;